import { apiErrorResponseSchema } from "@portfolio-demos/demo-core";
import { battleResponseSchema, type Rank, type Scenario, scenarioResponseSchema } from "./game";

const parseResponse = async <Result>(
  response: Response,
  parser: (body: unknown) => Result,
): Promise<Result> => {
  const body: unknown = await response.json();
  if (!response.ok) {
    const error = apiErrorResponseSchema.safeParse(body);
    throw new Error(
      error.success ? error.data.error.message : `Request failed with ${response.status}.`,
    );
  }
  return parser(body);
};

export const fetchScenario = async (signal?: AbortSignal): Promise<Scenario> => {
  const response = await fetch("/api/scenario", {
    headers: { accept: "application/json" },
    ...(signal ? { signal } : {}),
  });
  const parsed = await parseResponse(response, (body) => scenarioResponseSchema.parse(body));
  return parsed.data;
};

export const resolveContact = async (
  attackerRank: Rank,
  defenderId: string,
): Promise<ReturnType<typeof battleResponseSchema.parse>["data"]> => {
  const response = await fetch("/api/resolve", {
    method: "POST",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    body: JSON.stringify({ attackerRank, defenderId }),
  });
  const parsed = await parseResponse(response, (body) => battleResponseSchema.parse(body));
  return parsed.data;
};
